import { render, staticRenderFns } from "./study-demo.vue?vue&type=template&id=61be9bd5&scoped=true&"
import script from "./study-demo.vue?vue&type=script&lang=js&"
export * from "./study-demo.vue?vue&type=script&lang=js&"
import style0 from "./study-demo.vue?vue&type=style&index=0&id=61be9bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be9bd5",
  null
  
)

export default component.exports